import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitFilterGeoMappings = createSelector(
  [selectFinancialCockpitState],
  ({ filter }) => filter.geoMappings
)
